import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import {Link} from 'react-router-dom';

import {Grid} from 'react-bootstrap';
import Breadcrumbs from '../../breadcrumbs';
import {Wrapper} from 'system/wrapper';
import {DetailList, Divider, Image, DetailInfoWrapper} from './components';
import {InstitutionsList} from './components';
import List from '../../list';
import Spinner from 'spinner';

import {loadInstitutionDetail, loadSubordinateInstitutions} from '../../../redux/actions/portal/institutions';

import hospital from 'images/general/hospital.svg';
import doctor from 'images/general/doctor.svg';
import service from 'images/general/poslugi.svg';

const mapStateToProps = (state) => ({
  institutionDetail: state.institutions.get('institutionDetail'),
  subordinateInstitutions: state.institutions.get('institutionsSubordinateList'),
  isFetching: state.institutions.get('institutionsIsLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id, offset) => {
    dispatch(loadInstitutionDetail(id))
    dispatch(loadSubordinateInstitutions(id, "", offset))
  }

});

class InsitutionDetail extends Component {

  multilineStyle = {
    whiteSpace: 'pre-wrap',
    lineHeight: '1.3'
  }

  componentWillMount() {
    this.props.onLoad(this.props.match.params.id)
  }


  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.props.onLoad(nextProps.match.params.id)
    }
  }

  render() {

    const item = this.props.institutionDetail;

    if (this.props.institutionDetail === undefined || this.props.subordinateInstitutions === undefined) {
      return (
        <Wrapper>
          <Spinner/>
        </Wrapper>)
    }

    return(
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/institutions">Установи</Link></li>
          <li><Link to={`/institutions/detail/${item.get('id')}`}>{item.get('short_title')}</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>{item.get('full_title')}</h2>
            <DetailInfoWrapper>
              <Image>
              {item.get('photo') ? (
                    <div>
                      <img src={item.get('photo')} alt="hospital"/><br/>
                      </div>
                    ):(
                      <div>
                      <img src={hospital} alt="hospital"/><br/>
                      </div>
                    )}
              </Image>
            {this.props.isFetching ? (
              <Spinner />
            ):(
              <DetailList>

                <li><span>Адреса: </span>{item.get('address')}</li>
                <li><span>Код КОАТУУ: </span>{item.get('koatuu_code')}</li>
                <li><span>Код ЄДРПОУ: </span>{item.get('edrpou_code')}</li>
                {item.get('description') ? (
                   <li style={this.multilineStyle}><span>Додаткова інформація: </span>{item.get('description')}</li>
                ): (
                  <li><span>Додаткова інформація: </span>Відсутня</li>
                )}

              </DetailList>
            )}
             </DetailInfoWrapper>
            <Divider>
              <List>
                <li>
                  <Link to={`/institutions/detail/${item.get('id')}/personal`}>
                    <div>
                      <img src={doctor} alt="Лікарі"/>
                    </div>
                    <h3>Персонал</h3>
                  </Link>
                </li>
                <li>
                  <Link to={`/institutions/detail/${item.get('id')}/services`}>
                    <div>
                      <img src={service} alt="Лікарі"/>
                    </div>
                    <h3>Послуги</h3>
                  </Link>
                </li>

              </List>
              <Divider>
                <h2>Підпорядковані установи та підрозділи:</h2>
              </Divider>
              <Divider>
              {this.props.subordinateInstitutions.get('results').size > 0 ? (
                <InstitutionsList>
                  {this.props.subordinateInstitutions.get('results').map((item, i) => (
                    <li key={i}>
                      <Link to={`${item.get('id')}`}>
                        <h3>{item.get('full_title')}</h3>
                        <p>{item.get('address')}</p>
                      </Link>
                    </li>
                  ))}
                </InstitutionsList>
              ): (
                <h4>Підпорядковані установи та підрозділи відсутні</h4>
              )}
            </Divider>
            </Divider>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

InsitutionDetail.propTypes = {
  institutionDetail: PropTypes.instanceOf(Map),
  isFetching: PropTypes.bool,
  onLoad: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(InsitutionDetail);



// WEBPACK FOOTER //
// ./src/system/main/institutions/detail.js